import React, { FC } from "react";

import AdvertiserBasicDetails from "./AdvertiserBasicDetails";
import AdvertiserExtraDetails from "./AdvertiserExtraDetails";
import classes from "./AdvertiserDetailsSection.module.scss";
import { AdvertiserType } from "../../../types/advertiserTypes";

type AdvertiserInfoSectionProps = {
  advertisers: AdvertiserType[];
  advertiser: AdvertiserType;
  fetchAndSetAdvertiserDetailData: () => void;
};

const AdvertiserInfoSection: FC<AdvertiserInfoSectionProps> = ({
  advertisers,
  advertiser,
  fetchAndSetAdvertiserDetailData,
}) => {
  return (
    <div className={classes.container}>
      <AdvertiserBasicDetails advertiser={advertiser} advertisers={advertisers} />
      <AdvertiserExtraDetails
        advertiser={advertiser}
        fetchAndSetAdvertiserDetailData={fetchAndSetAdvertiserDetailData}
      />
    </div>
  );
};

export default AdvertiserInfoSection;
